"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailSession = void 0;
// external
const class_validator_1 = require("class-validator");
// local
const GenericSession_1 = require("../../../../apis/spg/models/GenericSession");
const RetailCustomer_1 = require("./RetailCustomer");
const errorTypes_1 = require("../../../../apis/spg/helpers/errorTypes");
/**
 * Represents a session required to access big retail services endpoints.
 */
class RetailSession extends GenericSession_1.GenericSession {
    filterSensitiveData() {
        const newSession = super.filterSensitiveData();
        return newSession;
    }
    serialize() {
        return Object.assign(Object.assign({}, super.serialize()), { createdAt: this.createdAt, availableLocations: this.availableLocations.map((availableLocation) => availableLocation.serialize()), retailCustomerId: this.retailCustomerId, retailCustomer: this.retailCustomer
                ? this.retailCustomer.serialize()
                : null, permissions: null });
    }
    static unserialize(data) {
        const newSession = super.unserialize(data);
        newSession.createdAt = data.createdAt;
        newSession.retailCustomerId = data.retailCustomerId;
        newSession.retailCustomer = data.retailCustomer
            ? RetailCustomer_1.RetailCustomer.unserialize(data.retailCustomer)
            : null;
        newSession.permissions = null;
        return newSession;
    }
    async validate() {
        const validated = await (0, class_validator_1.validate)(this);
        if (validated.length > 0) {
            throw new errorTypes_1.ValidationError(validated);
        }
        return true;
    }
    get isRetailCustomerBlocked() {
        var _a;
        return (_a = this.retailCustomer) === null || _a === void 0 ? void 0 : _a.isRetailCustomerBlocked;
    }
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)()
], RetailSession.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], RetailSession.prototype, "retailCustomerId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)()
], RetailSession.prototype, "retailCustomer", void 0);
exports.RetailSession = RetailSession;
//# sourceMappingURL=RetailSession.js.map